import styles from '../SpendingLimitDrawer.module.css';
import toolTipStyles from '../../../../ui/tooltip/Tooltip.module.css';
import { mapSellerProductToDurationInMonths } from '../../OfferChoiceForm/utils/mapSellerProductToDuration';
import { Tooltip } from '../../../../ui/tooltip';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';

export const UnavailableLimit = ({
    sellerProduct
}: {
    sellerProduct: 'THREE_MONTHS' | 'TWELVE_MONTHS';
}) => {
    const durationInMonths = mapSellerProductToDurationInMonths({
        sellerProduct: sellerProduct
    });

    return (
        <div>
            <div className={styles.loanDuration}>
                {durationInMonths} months purchases
            </div>
            <div className={styles.leftToSpend}>Left to spend:</div>
            <div className={styles.creditLimit}>
                <FormattedCurrency className={styles.creditLimit} value={0} />
                <Tooltip
                    variant="primary"
                    className={toolTipStyles.TooltipRight}
                    message="We can’t approve you for more funds right now - check back in 30 days and hit ‘Secure my limit’."
                />
            </div>
        </div>
    );
};
